import React from 'react';
import { Card, CardContent, CardHeader } from '@/shared/components/ui/Card';

interface RecordCardProps {
  icon?: React.ComponentType<{ className?: string }>;
  title: string;
  subtitle?: string;
  topRight?: React.ReactNode;
  metricsGrid?: React.ReactNode;
  alert?: React.ReactNode;
  footer?: React.ReactNode;
  onClick?: () => void;
}

export const RecordCard: React.FC<RecordCardProps> = ({
  icon: Icon,
  title,
  subtitle,
  topRight,
  metricsGrid,
  alert,
  footer,
  onClick,
}) => {
  return (
    <Card
      className={`hover:shadow-md transition-shadow ${
        onClick ? 'cursor-pointer hover:border-emerald-300/50' : ''
      }`}
      onClick={onClick}
    >
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2">
            {Icon && (
              <div className="p-2 bg-slate-50 rounded-lg border border-slate-200/50">
                <Icon className="h-4 w-4 text-slate-600" />
              </div>
            )}
            <div>
              <h3 className="font-semibold text-slate-900">{title}</h3>
              {subtitle && (
                <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>
              )}
            </div>
          </div>
          {topRight && <div className="flex items-center gap-2">{topRight}</div>}
        </div>
      </CardHeader>

      {(metricsGrid || alert || footer) && (
        <CardContent className="pt-0 space-y-3">
          {alert && (
            <div className="p-3 bg-amber-50 border border-amber-200/50 rounded-lg">
              {alert}
            </div>
          )}

          {metricsGrid && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {metricsGrid}
            </div>
          )}

          {footer && (
            <div className="pt-2 border-t border-slate-200/50 text-xs text-slate-500">
              {footer}
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
};
